module.exports = {"title":"Delete event","description":"Are you sure you want to delete that event?","delete":"Delete","cancel":"Cancel"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/ConfirmDeleteEventModal/locales/fr.json
// module id = 1305
// module chunks = 0